import {Paper, Typography } from "@mui/material";

export default function StatusRowItem({ children }) {
  if (typeof children === "number") children = children.toLocaleString();
  return (
    <Paper sx={{width:"45%", display: 'flex', justifyContent: 'center'}}>
      <Typography variant="h4" fontSize={'1.5em'}>{children}</Typography>
    </Paper>
  );
}
